import React, { Component } from "react";
import * as Cookies from "es-cookie";
import { Row, Col } from 'react-bootstrap';
import './_non-academic.scss';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import PreloaderTwo from "../../../preloader/PreloaderTwo";
import { GRADIENTS } from './naTheme';
import { ViewDetailsLink } from './naComponents';

// ─── GraphQL Queries (unchanged) ──────────────────────────────────────────────

const GET_FEE_DETAILS = gql`
  query($student_mobile: String) {
    getStudentFeeDetails(student_mobile: $student_mobile) {
      total_fees { fee_type total_amount pending_amount }
      paid_fees  { fee_type paid_amount  paid_date      }
      due_fees   { fee_type due_date     due_amount     }
    }
  }
`;

const GET_OFFLIE_RESULTS = gql`
  query($student_mobile: String, $timeline: Int) {
    getStudentExamResults(student_mobile: $student_mobile, timeline: $timeline) {
      year month date
      overall_total_rank overall_gained_rank
      overall_gained_marks overall_total_marks overall_avg
      exam_date
      student_marks {
        subject_id subject_wise_total_marks subject_wise_gained_rank
        subject_wise_gained_marks subject_wise_total_rank subject_wise_avg
      }
    }
  }
`;

const GET_ATTENDANCE_DETAILS = gql`
  query($student_mobile: String) {
    getStudentAttendance(student_mobile: $student_mobile) {
      year
      month {
        month no_of_present no_of_absent no_of_holidays no_of_days
        date { date is_holiday is_present dateStatus { attendance_type attended_status } }
      }
    }
  }
`;

const FETCH_PARENT_PERMISSION = gql`
  query($institute_id: Int!) {
    getParentsPermissionDetails(institute_id: $institute_id) {
      class_id exam_id branch_id section_id class_name exam_name branch_name section_name
      permission_id student_name roll_no student_mobile request_date from_datetime to_datetime
      receiver_name receiver_mobile request_message receiver_image_path parent_name parent_mobile
      permission_status comments approved_time approved_by outtime outtime_image_path
      outtime_inserted_by intime intime_image_path intime_inserted_by
      permission_request_type_id request_title
    }
  }
`;

// ─── Shared card styles ───────────────────────────────────────────────────────

const metricCardBase = {
  borderRadius: '16px',
  background:   '#FFFFFF',
  border:       '1px solid #E5E7EB',
  boxShadow:    '0 1px 4px rgba(0,0,0,0.06), 0 4px 20px rgba(91,95,239,0.07)',
  overflow:     'hidden',
  cursor:       'pointer',
  transition:   'box-shadow 0.25s ease, transform 0.25s ease',
  height:       '100%',
};

const onEnter = e => {
  e.currentTarget.style.boxShadow  = '0 4px 16px rgba(0,0,0,0.10), 0 8px 36px rgba(91,95,239,0.15)';
  e.currentTarget.style.transform  = 'translateY(-4px)';
};
const onLeave = e => {
  e.currentTarget.style.boxShadow  = '0 1px 4px rgba(0,0,0,0.06), 0 4px 20px rgba(91,95,239,0.07)';
  e.currentTarget.style.transform  = 'translateY(0)';
};

// Reusable stat row inside a card
const CardStatRow = ({ label, value, color, last }) => (
  <div style={{
    display:        'flex',
    justifyContent: 'space-between',
    alignItems:     'center',
    padding:        '9px 0',
    borderBottom:   last ? 'none' : '1px solid #F3F4F6',
  }}>
    <span style={{ color: '#6B7280', fontSize: '13px' }}>{label}</span>
    <span style={{ fontWeight: 700, color: color || '#111827', fontSize: '14px' }}>{value}</span>
  </div>
);

// ─── Component ────────────────────────────────────────────────────────────────

class NAOverAllDetails extends Component {

  render() {
    const currentDate  = new Date();
    const currentMonth = currentDate.getMonth() + 1;

    const feeDetails        = this.props.feeDetails;
    const offlineResults    = this.props.offlineResults;
    const attendanceDetails = this.props.attendanceDetails;
    const parentPermission  = this.props.parentPermission;

    if (feeDetails.loading || offlineResults.loading || attendanceDetails.loading || parentPermission.loading)
      return <PreloaderTwo />;

    if (feeDetails.error)        { alert("Server Error. " + feeDetails.error.message);        return null; }
    if (offlineResults.error)    { alert("Server Error. " + feeDetails.error.message);        return null; }
    if (attendanceDetails.error) { alert("Server Error. " + attendanceDetails.error.message); return null; }
    if (parentPermission.error)  { alert("Server Error. " + parentPermission.error.message);  return null; }

    // ── Business logic (unchanged) ─────────────────────────────────────────
    let totalfee = 0, paidfee = 0, pendingfee = 0;
    let examsConductedLength = 0, examsAttemptedLength = 0, overallPercentage = 0;
    let overAllAttendancePercentage = 0;

    if (attendanceDetails.getStudentAttendance.length > 0) {
      const currentYear      = new Date().getFullYear();
      const overallAttendance = attendanceDetails.getStudentAttendance
        .filter(item => item.year >= currentYear)[0]
        ?.month.filter(item1 => item1.month >= 1 && item1.month <= currentMonth);
      const noOfPresentDays  = overallAttendance?.reduce((acc, curr) => acc + curr.no_of_present,  0);
      const noOfHolidays     = overallAttendance?.reduce((acc, curr) => acc + curr.no_of_holidays, 0);
      const noOfDays         = overallAttendance?.reduce((acc, curr) => acc + curr.no_of_days,     0);
      if (noOfDays > 0) {
        overAllAttendancePercentage = (((noOfPresentDays + noOfHolidays) / noOfDays) * 100).toFixed(2);
      }
    }

    if (feeDetails.getStudentFeeDetails.length > 0) {
      totalfee   = feeDetails.getStudentFeeDetails[0]?.total_fees.reduce((a, c) => a + c.total_amount,   0);
      paidfee    = feeDetails.getStudentFeeDetails[0]?.paid_fees .reduce((a, c) => a + c.paid_amount,    0);
      pendingfee = feeDetails.getStudentFeeDetails[0]?.total_fees.reduce((a, c) => a + c.pending_amount, 0);
    }

    if (offlineResults.getStudentExamResults.length > 0) {
      examsConductedLength  = offlineResults.getStudentExamResults.length;
      examsAttemptedLength  = offlineResults.getStudentExamResults.length;
      const overallTotalMarks  = offlineResults.getStudentExamResults.reduce((a, c) => a + c.overall_total_marks,  0);
      const overallGainedMarks = offlineResults.getStudentExamResults.reduce((a, c) => a + c.overall_gained_marks, 0);
      overallPercentage = ((overallGainedMarks / overallTotalMarks) * 100).toFixed(2);
    }

    const students       = parentPermission.getParentsPermissionDetails
      .filter(item => item.student_name == this.props.stateData.studentData.student_name);
    // eslint-disable-next-line no-unused-vars
    const overallrequest = students.length;
    // eslint-disable-next-line no-unused-vars
    const totalrequest   = students.filter(item => item.permission_status == null).length;
    // eslint-disable-next-line no-unused-vars
    const totalaccept    = students.filter(item => item.permission_status == "1").length;
    // eslint-disable-next-line no-unused-vars
    const totaldecline   = students.filter(item => item.permission_status == "2").length;

    const attendanceColor = parseFloat(overAllAttendancePercentage) >= 75 ? '#047857' : '#B91C1C';

    // ── Render ─────────────────────────────────────────────────────────────
    return (
      <div style={{ padding: '4px 0 8px' }}>
        <Row>

          {/* ── Offline Marks ─────────────────────────────────────────── */}
          <Col sm={12} md={4} lg={4} style={{ marginBottom: '20px' }}>
            <div
              style={metricCardBase}
              onClick={() => this.props.selecthandleInputChange("non-academic", 0)}
              onMouseEnter={onEnter}
              onMouseLeave={onLeave}
            >
              <div style={{ background: GRADIENTS.marks, padding: '22px 20px', textAlign: 'center' }}>
                <i className="fas fa-file-alt" style={{ fontSize: '30px', color: 'rgba(255,255,255,0.92)', marginBottom: '10px', display: 'block' }} />
                <h6 style={{ color: '#fff', fontWeight: 700, margin: 0, fontSize: '13px', letterSpacing: '1px', textTransform: 'uppercase' }}>
                  Offline Marks
                </h6>
              </div>
              <div style={{ padding: '16px 20px 14px' }}>
                <CardStatRow label="Exams Taken"    value={`${examsAttemptedLength} / ${examsConductedLength}`} />
                <CardStatRow label="Avg Percentage" value={`${overallPercentage}%`} color="#D97706" last />
                <ViewDetailsLink onClick={() => this.props.selecthandleInputChange("non-academic", 0)} />
              </div>
            </div>
          </Col>

          {/* ── Attendance ────────────────────────────────────────────── */}
          <Col sm={12} md={4} lg={4} style={{ marginBottom: '20px' }}>
            <div
              style={metricCardBase}
              onClick={() => this.props.selecthandleInputChange("non-academic", 1)}
              onMouseEnter={onEnter}
              onMouseLeave={onLeave}
            >
              <div style={{ background: GRADIENTS.attendance, padding: '22px 20px', textAlign: 'center' }}>
                <i className="fas fa-calendar-check" style={{ fontSize: '30px', color: 'rgba(255,255,255,0.92)', marginBottom: '10px', display: 'block' }} />
                <h6 style={{ color: '#fff', fontWeight: 700, margin: 0, fontSize: '13px', letterSpacing: '1px', textTransform: 'uppercase' }}>
                  Attendance
                </h6>
              </div>
              <div style={{ padding: '16px 20px 14px' }}>
                <div style={{ textAlign: 'center', padding: '12px 0 14px' }}>
                  <div style={{ fontSize: '36px', fontWeight: 800, color: attendanceColor, lineHeight: 1 }}>
                    {overAllAttendancePercentage}%
                  </div>
                  <div style={{ fontSize: '12px', color: '#6B7280', marginTop: '4px' }}>Overall Attendance</div>
                </div>
                <ViewDetailsLink onClick={() => this.props.selecthandleInputChange("non-academic", 1)} />
              </div>
            </div>
          </Col>

          {/* ── Fees ──────────────────────────────────────────────────── */}
          <Col sm={12} md={4} lg={4} style={{ marginBottom: '20px' }}>
            <div
              style={metricCardBase}
              onClick={() => this.props.selecthandleInputChange("non-academic", 2)}
              onMouseEnter={onEnter}
              onMouseLeave={onLeave}
            >
              <div style={{ background: GRADIENTS.fees, padding: '22px 20px', textAlign: 'center' }}>
                <i className="fas fa-rupee-sign" style={{ fontSize: '30px', color: 'rgba(255,255,255,0.92)', marginBottom: '10px', display: 'block' }} />
                <h6 style={{ color: '#fff', fontWeight: 700, margin: 0, fontSize: '13px', letterSpacing: '1px', textTransform: 'uppercase' }}>
                  Fees
                </h6>
              </div>
              <div style={{ padding: '16px 20px 14px' }}>
                <CardStatRow label="Total Fees"   value={`₹${totalfee.toLocaleString()}/-`} />
                <CardStatRow label="Paid Fees"    value={`₹${paidfee.toLocaleString()}/-`}    color="#047857" />
                <CardStatRow label="Pending Fees" value={`₹${pendingfee.toLocaleString()}/-`} color="#B91C1C" last />
                <ViewDetailsLink onClick={() => this.props.selecthandleInputChange("non-academic", 2)} />
              </div>
            </div>
          </Col>

        </Row>
      </div>
    );
  }
}

// ─── Apollo HOC (unchanged) ───────────────────────────────────────────────────

export default withRouter(
  compose(
    graphql(GET_FEE_DETAILS, {
      options: props => ({
        variables:   { student_mobile: props.stateData.studentData.contact_no.toString() },
        fetchPolicy: 'network-only',
      }),
      name: "feeDetails",
    }),
    graphql(GET_OFFLIE_RESULTS, {
      options: props => ({
        variables:   { student_mobile: props.stateData.studentData.contact_no.toString(), timeline: parseInt(4) },
        fetchPolicy: 'network-only',
      }),
      name: "offlineResults",
    }),
    graphql(GET_ATTENDANCE_DETAILS, {
      options: props => ({
        variables:   { student_mobile: props.stateData.studentData.contact_no.toString() },
        fetchPolicy: 'network-only',
      }),
      name: "attendanceDetails",
    }),
    graphql(FETCH_PARENT_PERMISSION, {
      options: () => ({
        variables:   { institute_id: parseInt(Cookies.get("institutionid")) },
        fetchPolicy: 'cache-and-network',
      }),
      name: "parentPermission",
    }),
  )(NAOverAllDetails)
);
